module.exports = __webpack_public_path__ + "img/38.f7a86072.png";